import axios from "~/plugins/axios";

export default {
  paginateActive(
    page = 1,
    perPage = 15,
    filter = { },
    includes = [
      "model.search_thumbnail",
      "model.global_automation",
    ],
  ) {
    return axios.get("/web_api/v1/automationable/active", {
      params: {
        page,
        perPage,
        includes,
        ...filter,
        // On initial load filter hasn't been set yet, so we fetch from key value store
        noFilter: Object.keys(filter).length === 0 ? 1 : 0,
      },
    })
      .then((response) => response.data);
  },
  paginateOnce(
    page = 1,
    perPage = 15,
    filter = { },
    includes = [
      "model.search_thumbnail",
      "model.global_automation",
    ],
  ) {
    return axios.get("/web_api/v1/automationable/once", {
      params: {
        page,
        perPage,
        includes,
        ...filter,
        // On initial load filter hasn't been set yet, so we fetch from key value store
        noFilter: Object.keys(filter).length === 0 ? 1 : 0,
      },
    })
      .then((response) => response.data);
  },
  paginateInactive(
    page = 1,
    perPage = 15,
    filter = { },
    includes = [
      "model.search_thumbnail",
      "model.global_automation",
    ],
  ) {
    return axios.get("/web_api/v1/automationable/inactive", {
      params: {
        page,
        perPage,
        includes,
        ...filter,
        // On initial load filter hasn't been set yet, so we fetch from key value store
        noFilter: Object.keys(filter).length === 0 ? 1 : 0,
      },
    })
      .then((response) => response.data);
  },
};
